import React, { useState, useEffect } from "react";
import Button from "@material-ui/core/Button";
import { makeStyles } from "@material-ui/styles";
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import Hidden from "@material-ui/core/Hidden";
import { Router, Link } from "@reach/router";
import Divider from "@material-ui/core/Divider";
import { withSnackbar } from "notistack";
import SERVER_ADDRESS from "../../../config";
import store from "../../../reduxstore";
import { hasChildRoleOf, hasExactRole, hasExactRoleOf } from "../../../auth";
import TeacherGradePage from "./TeacherGradePage";
import StudentGradePage from "./StudentGradePage";
import { testNames, fullGrade, testNameList, simpleFullGrade } from "./config";

//过滤有效成绩, 数字成绩，大于0小于满分，是符合要求的类型之一,耗时为数字或空字符串且大于0
function filterValidGrade(grades) {
  return grades.filter(grade => {
    return (
      !isNaN(Number(grade.grade)) &&
      (grade.time_cost === "" || !isNaN(Number(grade.time_cost))) &&
      Number(grade.time_cost) >= 0 &&
      Object.keys(testNames).indexOf(grade.test_type) !== -1 &&
      Number(grade.grade) > 0 &&
      Number(grade.grade) <= fullGrade[grade.test_type]
    );
  });
}

//转换成绩数据格式
function transformGrade(grades) {
  return grades
    .map(grade => {
      const timeCost = grade.time_cost === "" ? "" : Number(grade.time_cost);
      let specification;
      if (grade.test_type === "a") {
        try {
          specification = JSON.parse(grade.specification);
        } catch (e) {
          specification = "notValid";
        }
      }
      return {
        ...grade,
        grade: Number(grade.grade),
        test_type: testNames[grade.test_type],
        time_cost: timeCost,
        specification: specification
      };
    })
    .filter(
      ({ specification, test_type }) =>
        test_type !== "构件辨识实验" || specification !== "notValid" //过滤掉JSON.parse失败的成绩
    );
}

//根据用户id filter
function gradeIdFilter(grades, userId) {
  return grades.filter(grade => {
    return grade.user === userId;
  });
}

const useStyles = makeStyles(theme => ({
  grid: {
    flexGrow: 1
  },
  categorybar: {
    padding: theme.spacing(4)
  },
  divider: {
    width: "100%",
    height: 1
  }
}));

//获取实验成绩
function useGrade(initValue, enqueueSnackbar, role, userId) {
  const [grades, setGrades] = useState(initValue);
  useEffect(() => {
    //教师fetch全部成绩
    if (hasChildRoleOf("教师")) {
      fetch(`${SERVER_ADDRESS}/api/vtestgrade.json/`, {
        headers: {
          Accept: "application/json, text/plain, */*"
        },
        mode: "cors",
        credentials: "include"
      })
        .then(res => {
          if (!res.ok) {
            throw Error(res.statusText);
          }
          return res.json();
        })
        .then(data => {
          //close dialog after finish post
          setGrades(transformGrade(filterValidGrade(data)));
          //成功后的反馈SnackBar
          // enqueueSnackbar("网络畅通", {
          //   variant: "success"
          // });
        })
        .catch(error => {
          //失败后显示错误SnackBar
          // console.log(error);
          enqueueSnackbar("无法连接服务器，请检查网络", {
            variant: "error"
          });
        });
    }
    //学生fetch本人成绩
    if (hasChildRoleOf("学生")) {
      fetch(`${SERVER_ADDRESS}/api/vtestgrade.json/?user=${userId}`, {
        headers: {
          Accept: "application/json, text/plain, */*"
        },
        mode: "cors",
        credentials: "include"
      })
        .then(res => {
          if (!res.ok) {
            throw Error(res.statusText);
          }
          return res.json();
        })
        .then(data => {
          //close dialog after finish post
          setGrades(transformGrade(filterValidGrade(data)));
          //成功后的反馈SnackBar
          // enqueueSnackbar("网络畅通", {
          //   variant: "success"
          // });
        })
        .catch(error => {
          //失败后显示错误SnackBar
          // console.log(error);
          enqueueSnackbar("无法连接服务器，请检查网络", {
            variant: "error"
          });
        });
    }

    return () => {
      setGrades(initValue);
    };
  }, []);

  return grades;
}

//获取各实验平均成绩
function getAverageGrade(grades) {
  const AverageGrade = {};
  testNameList.forEach(testName => {
    const gradeForThisTest = grades.filter(
      grade => grade.test_type === testName
    );
    let gradeSum = 0,
      avgGradeForTest;
    if (gradeForThisTest.length > 0) {
      gradeForThisTest.forEach(gradeNow => {
        gradeSum += gradeNow.grade;
      });
      avgGradeForTest = (gradeSum / gradeForThisTest.length).toFixed(0);
    } else {
      avgGradeForTest = 0;
    }
    AverageGrade[testName] = Number(avgGradeForTest);
  });
  return AverageGrade;
}

function GradePage(props) {
  const { account } = store.getState();
  const grades = useGrade([], props.enqueueSnackbar, account.role, account.id);
  const averageGrade = getAverageGrade(grades);
  return (
    <>
      {grades.length > 0 && (
        <>
          {hasChildRoleOf("教师") ? (
            <TeacherGradePage grades={grades} averageGrade={averageGrade} />
          ) : (
            <StudentGradePage grades={grades} averageGrade={averageGrade} />
          )}
        </>
      )}
    </>
  );
}

export default withSnackbar(GradePage);
